import { useFlags } from "launchdarkly-react-client-sdk";

import { useUserContext } from "../atlas/contexts/User/UserContextProvider";
import { isOnlyAiAdvantageBundle } from "../constants/bundles";

// Hide Assessments for AI-only tenants while the FF is off
export const useHideAssessmentsForBundle = (): boolean => {
  const { contentBundles } = useUserContext();
  const { taxonomyBundleFiltering } = useFlags();

  return !taxonomyBundleFiltering && isOnlyAiAdvantageBundle(contentBundles);
};
